<template>
    <div
        class="AlphabetSystemQuizView"
        @mousemove="drag"
        @mouseup="dragEnd"
        @mouseleave="dragEnd"
        @touchmove="drag"
        @touchend="dragEnd"
    >
        <div class="top-part-wrapper">
            <div class="progress-bar-wrapper">
                <div class="progress-bar" :style="{ width: percentageProgress + '%' }" />
            </div>

            <div class="exit-button-wrapper" @click="$router.go(-1)">{{ $t('systems.exit') }}</div>
            <h2>{{ $t('systems.instruction') }}</h2>
            <div class="drop-boxes">
                <div
                    v-for="number in matchBoxNumbers"
                    :key="number"
                    class="drop-box"
                    :number="number"
                    @mouseenter="iluminateTile"
                    @mouseleave="resetIluminationFromTile"
                >
                    {{ number }}
                </div>
            </div>
        </div>
        <div class="bottom-part-wrapper">
            <div v-if="stepItems.length" class="carousel-rail">
                <img
                    v-for="item in slideItems"
                    :key="item.number"
                    :number="item.number.split('-')[0]"
                    :src="createImagePath(item.number)"
                    :alt="item.name"
                    :draggable="false"
                    @mousedown="dragStart"
                    @touchstart="dragStart"
                />
            </div>
            <div v-if="carouselSlidesCount > 1" class="carousel-pagination">
                <div
                    v-for="i in carouselSlidesCount"
                    :key="i"
                    :class="{ active: i === carousel.activeSlideIndex + 1 }"
                    class="pagination-dot"
                    @click="carousel.activeSlideIndex = i - 1"
                />
            </div>
        </div>
    </div>
</template>

<script>
import quizMixin from './quiz.mixin';
import dragAndDropMixin from './dragAndDrop.mixin';

export default {
    mixins: [quizMixin, dragAndDropMixin],

    computed: {
        stepItems: {
            get: function () {
                return this.hasDifferentContentOnEachLocale ? this.step.items[this.currentLocale] : this.step.items;
            },
            set: function (newArr) {
                if (this.hasDifferentContentOnEachLocale) {
                    this.step.items[this.currentLocale] = newArr;
                } else {
                    this.step.items = newArr;
                }
            }
        },

        hasDifferentContentOnEachLocale() {
            return this.step.items[this.currentLocale];
        }
    },

    mounted() {
        this.setMatchBoxesNumbers();
        this.shuffleItemsInArray(this.stepItems);
    },

    methods: {
        createImagePath(imageName) {
            const alphabetSystemImageName = imageName.split('-')[0];
            // we can't have line breaks in src string thats why disable pretttier for this line
            // prettier-ignore
            return require(`@/assets/images/system-images/${this.urlifyString(this.system.name)}/${this.urlifyString(this.journey.name)}/${this.urlifyString(this.step.name)}/${alphabetSystemImageName}.jpg`);
        }
    }
};
</script>

<style lang="scss" scoped>
.AlphabetSystemQuizView {
    width: 375px;
    height: 809px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 10px;
    .progress-bar-wrapper {
        height: 10px;

        .progress-bar {
            transition: 0.5s;
            background: white;
            height: 100%;
            width: 0;
        }
    }
    .exit-button-wrapper {
        text-align: right;
        margin-top: 10px;
        color: hsla(0, 0%, 100%, 0.5);
    }
    h2 {
        font-size: 21px;
        font-weight: normal;
        text-align: center;
        margin-top: 30px;
    }
    .drop-boxes {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20px;
        .drop-box {
            min-width: 75px;
            min-height: 75px;
            max-width: 75px;
            max-height: 75px;
            border: 1px dashed hsla(0, 0%, 100%, 0.5);
            border-radius: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 22px;
            color: hsla(0, 0%, 100%, 0.5);
            margin: 7.5px;
            transition: 0.5s;
        }
    }
    .bottom-part-wrapper {
        position: relative;

        .carousel-rail {
            display: flex;
            background: hsla(0, 0%, 100%, 0.5);
            padding: 5px;
            border-radius: 10px;
            img {
                width: calc(20% - 5px);
                border-radius: 10px;
                margin-right: 5px;
            }
        }

        .carousel-pagination {
            display: flex;
            justify-content: center;
            margin-top: 20px;
            .pagination-dot {
                width: 10px;
                height: 10px;
                background: hsla(0, 0%, 100%, 0.5);
                margin: 5px;
                border-radius: 50%;
                &.active {
                    background: white;
                }
            }
        }
    }
}
</style>
